import React from 'react';
import { ucWords } from '../../../Utilities/Utilities';
import { Link } from 'react-router-dom';
import { DEFAULT_LOCAL_PATH } from '../../../constents';
import { FcIphone } from 'react-icons/fc';
import { BiPhone } from 'react-icons/bi';
import { MdOutlineEmail } from 'react-icons/md';
import parse from 'html-react-parser';

function ReferralList({
  item,
  handlePopupOpen,
  handleDeleteReferral,
  handleReload,
}) {
  return (
    <>
      <span className="pacolm5">{item.chart_number}</span>
      <span className="pacolm5">
        <Link
          to={`${DEFAULT_LOCAL_PATH}/patient/counNote/${item.id}`}
        >{`${ucWords(item.patientName)}`}</Link>
        <br />
        {`${ucWords(item.gender)} ${item?.dob}`}
      </span>
      <span className="pacolm4">
        <FcIphone /> {item.mobile ? item.mobile : ' N/A'}
        <br />
        <BiPhone /> {item?.home_phone ? item?.home_phone : ' N/A'}
        <br />
        <MdOutlineEmail />
        {item?.patEmail ? item?.patEmail : ' N/A'}
      </span>
      <span className="pacolm5">
        {`${ucWords(item.address)},`}
        <br />
        {`${ucWords(item.city)},`}
        <br />
        {`${ucWords(item.state_name)}`} <br />
        {item.zip}
      </span>
      <span className="pacolm4">{parse(item?.referringProvider)}</span>
      <span className="pacolm5">{parse(item?.referredTo)}</span>
      <span className="pacolm5">{parse(item?.urgency)}</span>
      <span className="pacolm5">{parse(item?.reasonForReferral)}</span>
      <span className="pacolm4">{item?.planDate}</span>
      <span className="pacolm4">{item?.noteStatus}</span>
      <span className="pacolm4">
        {/* <Link to={`#`}>{`${item?.docSent}`}</Link>/<Link to={`#`}>View</Link> */}
        {item?.docSent}
      </span>
      <span className="pacolm4">
        {/* Appt.: <Link to={`#`}>{item?.appTaken}</Link> <br /> Pt. Informed:
        <Link to={`#`}>{item?.patInformed}</Link> */}
        Appt.: {item?.appTaken} <br /> Pt. Informed:
        {item?.patInformed}
      </span>
      <span className="pacolm4">
        <Link
          to={`#`}
          onClick={() =>
            handlePopupOpen(
              item.id,
              item.rptSentId,
              item.patient_id,
              item.report_id,
            )
          }
        >
          New Referral
        </Link>
        {` | `}
        <Link to={`#`} onClick={() => handleDeleteReferral(item.id)}>
          Delete
        </Link>
      </span>
    </>
  );
}

export default ReferralList;
